import { render, staticRenderFns } from "./AddLogistics.vue?vue&type=template&id=3e4924f9&scoped=true&"
import script from "./AddLogistics.vue?vue&type=script&lang=js&"
export * from "./AddLogistics.vue?vue&type=script&lang=js&"
import style0 from "./AddLogistics.vue?vue&type=style&index=0&id=3e4924f9&lang=scss&scoped=true&"
import style1 from "./AddLogistics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4924f9",
  null
  
)

export default component.exports